<template>
  <div>
    <TopHeader code="course" />

    <section class="container-fluid uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link to="" class="item">课程</router-link>
              <router-link to="" class="item">
                {{ this.treeSelName }}
              </router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24 col-sm-6">
            <div class="g-sideMenu">
              <div class="title" @click="handleTreeRoot">全部课程</div>
              <div class="list">
                <el-tree
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :expand-on-click-node="false"
                  :data="treeData.children"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                ></el-tree>
              </div>
            </div>
          </div>

          <div class="col-24 col-sm-18">
            <section
              class="uc-knowledgeFilter uc-ml10"
              v-if="tagList.length > 0"
            >
              <div class="item" v-for="(item, index) in tagList" :key="index">
                <span class="txt">{{ item.name }}</span>
                <div class="con">
                  <a
                    href="javascript:;"
                    :class="tagSel[index] === undefined ? 'on' : ''"
                    @click="handleTagClick(index, undefined)"
                    >全部</a
                  >
                  <a
                    href="javascript:;"
                    v-for="(item, index2) in item.tag_list"
                    :key="index2"
                    :class="tagSel[index] === item.id ? 'on' : ''"
                    @click="handleTagClick(index, item.id)"
                    >{{ item.label }}</a
                  >
                </div>
              </div>
            </section>

            <section class="g-filterSearch uc-ml10">
              <!-- <div
                v-for="(item, index) in tabList"
                :key="index"
                class="item"
                :class="item.status == query.orderby ? 'on' : ''"
                @click="
                  query.orderby = item.status;
                  loadData();
                "
              >
                {{ item.name }}
              </div> -->
              <div class="search">
                <el-dropdown
                  @command="handleCommand"
                  style="line-height: 44px; margin-right: 5px"
                >
                  <span class="el-dropdown-link">
                    {{ custom
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in dropDownData"
                      :key="index"
                      :command="{ value: item.val, label: item.label }"
                      >{{ item.label }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <input
                  type="text"
                  placeholder="请输入您想搜索的课程"
                  class="uc-input"
                  v-model="query.keyword"
                  @keyup.enter="
                    query.pageIndex = 1;
                    loadData();
                  "
                />
                <input
                  type="submit"
                  value="搜索"
                  class="uc-btn blue"
                  @click="
                    query.pageIndex = 1;
                    loadData();
                  "
                />
              </div>
            </section>

            <section class="g-list style-radius uc-ml10">
              <div class="content-empty" v-if="list.total_count == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div
                v-for="(item, index) in list.items"
                :key="index"
                class="item"
              >
                <router-link
                  :to="{
                    name: 'CourseDetails',
                    params: { id: item.id },
                  }"
                  class="con"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <!-- <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.tag_name"
                      class="txt"
                      v-if="item.tag_items.length > 0"
                    >
                      <div class="txt">
                        <span
                          style="margin-right:10px;"
                          v-for="(v, i) in item.tag_items"
                          :key="i"
                          >{{ v.label }}</span
                        >
                      </div>
                    </el-tooltip> -->
                    <div class="txt">
                      {{ item.lecturer_name || '无讲师' }}
                      | {{ item.period }}分钟 | {{ item.score }}学分 |
                      {{ item.like_num }}赞
                    </div>
                  </div>
                </router-link>
              </div>
            </section>

            <el-pagination
              class="uc-prvNxt"
              background
              layout="prev, pager, next"
              hide-on-single-page
              :current-page="query.pageIndex"
              :page-size="query.pageSize"
              :total="list.total_count"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'Course',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      tagSel: [],
      tabList: [
        { name: '最新', status: 0 },
        // { name: '最热', status: 1 },
        { name: '最多点赞', status: 2 },
      ],
      query: {
        tagId: undefined,
        pageIndex: 1,
        pageSize: 9,
        orderby: 1,
        keyword: this.$route.query.keyword,
      },
      list: [],
      tagList: [],
      treeData: {},
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      treeSelName: '全部',
      dropDownData: [
        // { label: '智能检索', val: 0 },
        { label: '最新', val: 1 },
        { label: '最热', val: 2 },
      ],
      custom: '最新',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loadData();
      this.getTags();
      this.getCatalogTree();
    },
    loadData() {
      if (this.query.orderby < 2) {
        this.getNewestCourses();
      } else {
        this.getLikeCourses();
      }
    },
    async getTags() {
      const response = await this.$api.tag.getTags();
      this.tagList = response.data.data;
    },
    async getCatalogTree() {
      const response = await this.$api.course.getCatalogTree();
      this.treeData = response.data.data;
    },
    async getNewestCourses() {
      const response = await this.$api.course.getCourses(this.query);
      this.list = response.data.data;
    },
    async getHotCourses() {
      const response = await this.$api.course.getHotCourses(this.query);
      this.list = response.data.data;
    },
    async getLikeCourses() {
      const response = await this.$api.course.getLikeCourses(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    // 切换标签
    handleTagClick(index, tagId) {
      if (this.tagSel[index] === tagId) {
        return;
      }
      this.tagSel[index] = tagId;
      const tagArr = [];
      for (const tag of this.tagSel) {
        if (tag) {
          tagArr.push(tag);
        }
      }
      this.query.tagId = tagArr.toString();
      this.loadData();
    },
    // 切换目录
    handleNodeClick(item) {
      this.query.catalogId = item.id;
      this.treeSelName = item.name;
      this.loadData();
    },
    // 根目录
    handleTreeRoot() {
      this.query.catalogId = undefined;
      this.$refs.tree.setCurrentKey(null);
      this.treeSelName = '全部';
      this.loadData();
    },
    handleCommand(command) {
      this.custom = command.label;
      this.query.orderby = command.value;
      this.loadData();
    },
  },
};
</script>
